import React from "react";
import axios, { axiosAuth } from "@dreamchimney/react-axios";

export const defineContainer = (callback, Component, useAxios) => {
  class Container extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        failure: null,
        loading: true,
        data: null,
        page: 1,
        axios: useAxios !== null ? useAxios : axios,
      };
    }

    render() {
      const { failure, loading, data } = this.state;
      const { useLoadMore } = this.props;

      // override default state if needed
      const defaultState = (state) => {
        this.setState({ ...this.state, ...state });
      };

      // const api = axios.create({
      //   baseURL: environment.isDevelopment ? "http://www.dc.local" : `http://www.dreamchimney.com`
      // });

      const request = (...args) => {
        this.setState({ ...this.state, loading: true, page: useLoadMore && args[0].page ? args[0].page : 1 });
        return callback(this.state.axios, ...args)
          .then((data) => {
            if (useLoadMore && this.state.page > 1) {
              let clone = this.state.data.data.slice(0);
              data.data = clone.concat(data.data);
            }
            this.setState({ ...this.state, failure: false, loading: false, data });
            return data;
          })
          .catch((e) => {
            console.log("failure:", e);
            this.setState({ ...this.state, failure: true, loading: false });
            return {};
          });
      };
      const props = {
        defaultState,
        request,
        loading,
        failure,
        data,
        ...this.props,
        axios: this.state.axios,
      };
      return <Component {...props} />;
    }
  }
  return Container;
};

export const CreateContainer = (callback, Component, useAxios = null) => {
  const Container = defineContainer(callback, Component, useAxios);
  return Container;
};

export const withAuthCreateContainer = (callback, Component) => CreateContainer(callback, Component, axiosAuth);
// console.log("!!!! with callback", callback) && <CreateContainer callback={callback} Component={Component} useAxios={axiosAuth} />;
// export default withAuthCreateContainer(CreateContainer);
